<template>
  <div>
    <!-- 取消费开城 -->
    <template v-if="isOpenCancelFee">
      <section class="record--rules-page bg-light-gray">
        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <span style="font-weight: bold">取消收费规则</span>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              为保证平台公平性，维护司乘双方权益，小拉平台推出了取消收费规则。您可以在车主接单后3分钟内免费取消，若由于您个人原因超时取消，属于您的责任，需要支付取消费用。若由于车主、平台或其他外界原因，则您无需支付。
            </span>
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <span style="font-weight: bold">取消费按以下标准收取：</span>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>车主接单后3分钟，取消费2元。</span>
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <li style="font-weight: bold">
              以下情况属于您有责取消，需要支付取消费用
            </li>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              若您在车主接单3分钟后取消订单，平台将对您的取消行为收取取消费用（若<span
                style="color: red"
                >车主原因</span
              >造成取消，如<span style="color: red">车主迟到</span
              >等行为，将不会收取您取消费）。
            </span>
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <li style="font-weight: bold">以下情况无需支付取消费</li>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>1、您在车主接单后3分钟内取消订单。</span>
            <br />
            <span
              >2、车主未在规定时间内（详见软件提示）到达上车点，您取消订单</span
            >
            <br />
            <span
              >3、系统预估车主无法按照规定时间内（详见软件提示）到达上车点，您取消订单。</span
            >
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <li style="font-weight: bold">车主责任导致订单取消对车主的影响</li>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              若订单取消是车主责任，或您对车主的投诉被平台核实成立，将会影响车主的考核指标。
            </span>
          </div>
        </div>
      </section>
    </template>
    <!-- 未开城 -->
    <template v-else>
      <section class="record--rules-page bg-light-gray">
        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <span style="font-weight: bold">限时取消规则</span>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              为保证平台公平性，维护司乘双方权益，小拉平台推出了<span
                style="font-weight: bold"
                >限时取消规则</span
              >。您可以在车主接单后3分钟内免责取消，若由于您个人原因超时取消，属于您的责任。若由于车主、平台或其他外界原因，您可免责取消。
            </span>
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <span style="font-weight: bold">以下情况您可无责取消</span>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              1. 您在车主接单后<span style="font-weight: bold">3分钟内</span
              >取消订单。
            </span>
            <br />
            <span
              >2. 车主未在规定时间内（详见软件提示）到达上车点，您取消订单</span
            >
            <br />
            <span
              >3.
              车主未朝上车点行驶，或以其他各种理由不来接驾时，您取消订单。</span
            >
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <span style="font-weight: bold">以下情况属于您有责取消</span>
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              若您在<span style="font-weight: bold">车主接单3分钟后</span
              >取消订单，平台将对您的取消行为进行责任审核（若<span
                style="font-weight: bold"
                >车主原因</span
              >造成取消，如<span style="font-weight: bold">车主迟到</span
              >等行为，将不会判定为您的责任）。<span style="font-weight: bold"
                >若取消订单被平台多次判定是您的责任，可能影响您后续的叫车服务。</span
              >
            </span>
          </div>
        </div>

        <div class="Editable-unstyled">
          <div class="public-DraftStyleDefault-block">
            <span style="font-weight: bold"
              >车主责任导致订单取消对车主的影响</span
            >
          </div>
          <div class="public-DraftStyleDefault-block">
            <span>
              若订单取消是车主责任，或您对车主的投诉被平台核实成立，将会影响车主的考核指标。
            </span>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    isOpenCancelFee() {
      // 没传参数时，就当做取消费开城，兼容端上
      return [undefined, '1'].includes(this.$route.query.isOpenCancelFee);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="less" scoped>
.record--rules-page {
  padding: 12px 18px 32px 18px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  background-color: white;
}
.Editable-unstyled {
  margin-bottom: 12px;
}
.Editable-unstyled-first {
  margin-bottom: 32px;
}
.Editable-unstyled-notBottom {
  margin-bottom: 0;
}
.public-DraftStyleDefault-block {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  line-height: 22px;
}
</style>
